import { Dialog, styled } from "@mui/material";
import { FileIconButton } from "../AttachedFiles/styles";

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});

export const StyledFileIconButton = styled(FileIconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  width: "40px",
  height: "40px",
}));
